import { ChildInfoSubmitter } from '../../lib/child-info/child-info-submit.service'
import { DocsChildInfoSubmitter } from './docs-child-info-submitter.service'

export const PROVIDERS = [
  {
    provide: ChildInfoSubmitter,
    useClass: DocsChildInfoSubmitter,
  }
]
